import React from "react";
import "./Footer.css";
import logo from "../../assets/logo2.png";
import {
  AiOutlineMail,
  AiOutlinePhone,
  AiOutlineInstagram,
} from "react-icons/ai";

function Footer() {
  return (
    <div className="footer-container pt-5" id="contact">
      <h3 className="title">Behöver du hjälp med städningen ? Kontakta oss</h3>
      <div className="row ">
        <div className="col-10 mx-auto mb-4 col-md-4 phone ">
          <div>
            <span>
              <a
                href="https://instagram.com/rent_stad_spanga?igshid=YmMyMTA2M2Y="
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <AiOutlineInstagram size={20} />
              </a>
            </span>
          </div>
          <div>
            <AiOutlineMail />
            inforentstad@gmail.com
          </div>
          <div>
            <AiOutlinePhone />
            07 07 58 98 38
          </div>
        </div>
        <div className="col-10 mx-auto mb-4 col-md-4 logo">
          <div>
            <img className="logo-footer" src={logo} alt="" />
          </div>
        </div>
        <div className="col-10 mx-auto mb-4 col-md-4 working-hours ">
          <div className="text-center">Öppettider :</div>
          <div> Måndag - fredag: </div>
          <div> 08.00 - 17.00</div>
          <div>Lördag - söndag stängt</div>
        </div>
      </div>
      <div>
        <a
          href="https://www.nextek.se/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Digital magic by Nextek
        </a>
      </div>
    </div>
  );
}

export default Footer;
